import React from 'react';
import classNames from 'classnames';

import {SearchIcon} from '../icons/SearchIcon';
import {Button} from '../Button';
import {LoadingHorizontal} from '../LoadingHorizontal';
import {Tooltip} from '../Tooltip';

export interface SearchHeaderProps {
    /** Resolved HTML text label (may contain <b> tags) */
    label: string;
    isCallToSearch: boolean;
    nothingFoundAnywhere: boolean;
    isSearching: boolean;
    searchButtonLabel: string;
    searchButtonTooltip: string;
    onSearch: () => void;
}

export const SearchHeader = ({
    label,
    isCallToSearch,
    nothingFoundAnywhere,
    isSearching,
    searchButtonLabel,
    searchButtonTooltip,
    onSearch,
}: SearchHeaderProps) => {
    return (
        <div className="sr-header-wrapper" onClick={onSearch}>
            <div
                className={classNames({
                    'sr-header': true,
                    'sr-call-to-search': isCallToSearch,
                    'sr-call-to-empty': nothingFoundAnywhere,
                })}
            >
                <SearchIcon size={20} colorOverwritten={true}/>
                <span
                    className="sr-text title-medium"
                    dangerouslySetInnerHTML={{__html: label}}
                />
                {isCallToSearch ? (
                    <Tooltip title={searchButtonTooltip} menuPlacement="block-end">
                        <div>
                            <Button
                                style="solid"
                                type="primary"
                                size="sm"
                                onClick={() => {}}
                                text={searchButtonLabel}
                            />
                        </div>
                    </Tooltip>
                ) : null}
            </div>
            <LoadingHorizontal isVisible={isSearching}/>
        </div>
    );
};
